import ActionButton, { type ActionButtonProps } from './ActionButton';
import { Delete as DeleteIcon } from '@mui/icons-material';

type DeleteButtonProps = Omit<ActionButtonProps, 'children'>;

const DeleteButton = (props: DeleteButtonProps) => (
  <ActionButton color="error" {...props}>
    <DeleteIcon />
  </ActionButton>
);

export default DeleteButton;
